<template>
  <div class="relative border-gray-500 border-solid border p-6">
    <div class="absolute z-50 w-full grid place-items-end" v-if="isPopular">
      <div class="bg-black shrink font-medium right-0 top-0 text-white p-2 rounded-bl-3xl flex items-center space-x-2">
        <span> Popular Choices! </span>
        <NuxtImg alt="logo medal" src="/shield-medal.png" class="w-6 h-6" format="webp" />
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-[320px_1fr] overflow-hidden gap-4">
      <div>
        <SlideImageProductSlide :images="images" />
      </div>

      <div class="px-0 md:px-8 md:space-y-12 space-y-8 pt-8">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <h2 class="text-xl lg:text-[32px] font-medium">
              {{ props.product?.name ?? 'Swing' }}
            </h2>
            <p>{{ props.product?.location }}</p>
          </div>

          <div class="md:text-right">
            <p>{{ $t('combo.tagline') }}</p>
            <p class="md:text-xl font-medium">{{ formatCurrency(Number(props.product?.price)) }}</p>
          </div>
        </div>

        <div class="grid grid-cols-1 gap-16">
          <div
            v-if="props.product?.id_description"
            class="line-clamp-4 -tracking-tight"
            v-html="props.product.id_description"
          ></div>
          <p v-else class="line-clamp-4">....</p>
        </div>

        <hr />

        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
          <span class="pr-4">
            <Icon name="ion:clock"></Icon>
            <span class="text-slate-400 pl-2">{{ props.product.activity_hours }}</span>
          </span>

          <span>
            <Icon name="ant-design:thunderbolt-outlined"></Icon>
            <span class="text-slate-400 pl-2">{{ props.product.booking_method }}</span>
          </span>

          <NuxtLink
            :to="link"
            no-prefetch
            class="pt-2 text-center font-bold inline-block cursor-pointer align-middle w-[200px] h-[40px] bg-cover bg-center bg-no-repeat bg-[url('/btn-yellow.png')] hover:bg-[url('/btn-black.png')] hover:text-[#efac1d]"
          >
            {{ $t('book_now_txt') }}
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { Product } from '@/types'
// import { PropType } from 'vue'

const { formatCurrency } = useMoneyFormat()
// const { locale } = useI18n()
const props = defineProps<{
  isPopular?: boolean
  product: Product
}>()

const images = computed(() => {
  if (!props.product?.images) {
    return []
  }
  return props.product?.images?.map(el => el.image) ?? []
})

const link = computed(() => {
  return `/activities/combo/${props.product?.slug ?? 'atv'}`
})
</script>
